"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetGuildsResponseAllOfToJSON = exports.GetGuildsResponseAllOfFromJSONTyped = exports.GetGuildsResponseAllOfFromJSON = void 0;
var _1 = require("./");
function GetGuildsResponseAllOfFromJSON(json) {
    return GetGuildsResponseAllOfFromJSONTyped(json, false);
}
exports.GetGuildsResponseAllOfFromJSON = GetGuildsResponseAllOfFromJSON;
function GetGuildsResponseAllOfFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'guilds': (json['guilds'].map(_1.GuildFromJSON)),
    };
}
exports.GetGuildsResponseAllOfFromJSONTyped = GetGuildsResponseAllOfFromJSONTyped;
function GetGuildsResponseAllOfToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'guilds': (value.guilds.map(_1.GuildToJSON)),
    };
}
exports.GetGuildsResponseAllOfToJSON = GetGuildsResponseAllOfToJSON;
